<template>
  <FinancialCardTable
    :title="$t('pages.financialPosition.toExpireValues')"
    :headers="toExpireHeaders"
    :items="financialPosition.toExpire"
    :unitFinancialPositions="unitFinancialPositions"
    mode="toExpire"
    :loading="loading"
    :no-data-text="pageParams.emptyState.toExpire"
    :expand-column="expandColumn"
    :slip-details-headers="slipDetailsHeaders"
  >
    <!-- Personaliza a coluna "acao" -->
    <template v-slot:col-action="props">
      <!-- Sua renderização customizada aqui -->
      <payment-button
        v-if="props.item.allowToPay && !debitBlock"
        :item="props.item"
        :email="email"
        :cellphone="cellphone"
        :buttonClass="'financial--background financial__pay-btn'"
        @openSlip="OnPaySlip(selectedUnit, props.item)"
        :sendByEmail="OnSendSlipByEmailToExpire"
        :sendBySms="OnSendSlipBySmsToExpire"
      />
    </template>

    <template v-slot:col-discountedValue="props">
      <span class="financial__discounted-value">
        {{
          formatMoney(
            !(props.item.contractQty >= 2)
              ? props.item.discountedValue
              : props.item[expandColumn].total
          )
        }}
        <v-tooltip
          top
          color="grey lighten-3"
          max-width="300"
          class="no-print"
          v-if="props.item.allowToPay && !debitBlock"
        >
          <span class="tooltip__text no-print">
            {{ enums.financialPositionToExpireTooltip }}
          </span>

          <span slot="activator" class="no-print">
            <i class="bexsicon-info tooltip__icon" style="padding: 0 10px" />
          </span>
        </v-tooltip>
      </span>
    </template>

    <template v-slot:expandcol-contractTitle="expandProps">
      <span class="financial__discounted-value">
        {{ getContractTitle(expandProps.item) }}
      </span>
    </template>
  </FinancialCardTable>
</template>

<script>
import FinancialCardTable from './FinancialCardTable.vue';
import PaymentButton from '@/components/financial/PaymentButton';
import { APP, FEATURE_TOGGLES } from '../../utils/constants';
export default {
  name: 'ToExpireTable',
  components: {
    FinancialCardTable,
    PaymentButton,
  },
  props: {
    financialPosition: { type: Object },
    slipDetailsHeaders: { type: Array, default: () => [] },
    unitFinancialPositions: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    noDataText: { type: String, default: 'Nenhum dado encontrado' },
    expandColumn: {
      type: String,
      default: 'slipsUnion',
    },
    email: { type: String },
    cellphone: { type: Object },
    debitBlock: { type: Boolean },
  },
  computed: {
    unifiedSlipsEnabled() {
      return this.$store.getters[FEATURE_TOGGLES.UNIT_FINANCIAL_POSITION];
    },
    showUnifiedSingleContract() {
      return this.$store.getters[FEATURE_TOGGLES.SHOW_UNIFIED_SINGLE_CONTRACT];
    },
    toExpireHeaders() {
      return this.visibleHeaders(this.toExpireHeadersConfig);
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].financialPosition,
      expandColumnPagination: {
        sortBy: 'contractId', // campo inicial para ordenação
        descending: false, // true = decrescente, false = crescente
      },
      toExpireHeadersConfig: [
        {
          text: ' ',
          value: 'slipsUnion',
          align: 'left',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: 'Vencimento',
          value: 'expirationDate',
          formatter: this.formatUtcDate,
          align: 'center',
        },
        {
          text: 'Valor',
          value: 'discountedValue',
          // formatter: this.formatMoney,
          formatter: (v, item, headerValue, extraInfo) =>
            extraInfo == 'slipsUnion'
              ? this.formatMoney(v, item, headerValue, extraInfo)
              : this.formatUnifiedValue(v, item, headerValue, extraInfo),
          align: 'center',
          itemClass: 'text-xs-center bold--text',
        },
        {
          text: ' ',
          value: 'action',
          align: 'center',
          class: 'no-print',
          itemClass: 'text-xs-center third-fit-in-mobile',
        },
      ],
    };
  },
  methods: {
    visibleHeaders(headers, mobile = this.mobile) {
      return headers.filter((header) =>
        mobile ? header.showMobile !== false : header.showDesktop !== false
      );
    },
    OnPaySlip(selectedUnit, slip) {
      if (slip.ready) {
        if (slip.slipUrl.hash) {
          window.open(getSlipUrl(slip.slipUrl.hash));
        } else {
          window.open(slip.slipUrl);
        }
      } else {
        window.open('/boleto-indisponivel');
      }
      const slipContract = this.selectedContract;
      const traceInfo = {
        contractId: slipContract.id,
        contractType: slipContract.type,
        detachedType: this.getContractTitle(slipContract),
        expirationDate: slip.expirationDate,
        serieId: slip.serieId,
        serieCode: slip.serieCode,
        parcelCode: slip.parcelCode,
        discountedValue: slip.discountedValue,
        ready: slip.ready,
        url: slip.slipUrl,
      };
      const traceAction =
        this.enums.logTraceActions.toExpirePaymentSlipDownloadFinancialPosition;
      this.createTrace(traceAction, traceInfo, this.currentContract.id);

      const notificationInfo = {
        ctx: this,
        notification: {
          id: slip.id.toString(),
          type: notificationTypes.TO_EXPIRE_SLIPS,
        },
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);
    },
    async OnSendSlipByEmailToExpire(item, cellphone, fromHome = false) {
      return await this.sendSlipByEmailToExpire(
        { ...item, contractId: this.selectedContract.id },
        cellphone,
        fromHome
      );
    },
    async OnSendSlipBySmsToExpire(item, cellphone, fromHome = false) {
      return await this.sendSlipBySmsToExpire(
        { ...item, contractId: this.selectedContract.id },
        cellphone,
        fromHome
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/financial/ToExpireTable.vue